import React from 'react'

/**
 * Calls "func" only when this hook unmounts. Changes of "func" doesn't cause it to be called.
 * @param func Function to call when this hook unmounts.
 * @param preventCallOnUnmount Prevents "func" to be called on unmount. Used to avoid conditional hook rendering.
 */
export function useOnUnmount(func: () => void, preventCallOnUnmount = false) {
    const didUnmount = React.useRef(false)

    // These two effects must be in this order.
    // First one sets the didUnmount so second one knows it really is unmount event instead of change of "func"
    React.useEffect(() => {
        return () => {
            didUnmount.current = true
        }
    }, [])

    React.useEffect(() => {
        return () => {
            if (didUnmount.current && !preventCallOnUnmount) {
                // call only on unmount
                func()
            }
        }
    }, [func, preventCallOnUnmount])
}
